export const WORD_COUNT_MODAL_SELECTORS = {
   DOCUMENT_WORDS: '#documentWords',
   DOCUMENT_CHARACTERS: '#documentCharacters',
   DOCUMENT_CHARACTERS_WITHOUT_SPACES: '#documentCharactersWithoutSpaces',
   SELECTION_WORDS: '#selectionWords',
   SELECTION_CHARACTERS: '#selectionCharacters',
   SELECTION_CHARACTERS_WITHOUT_SPACES: '#selectionCharactersWithoutSpaces',
} as const;